import React from 'react';
import theme from 'design-system/product/theme';
import Popover from 'react-scale/components/design-system/Popover';
import { ReactJsonView } from 'react-scale/corp/components/ReactJsonView';

interface TaskMetadataPopoverProps {
  fromReviewHeader: boolean;
  taskMetadata: Record<any, any>;
}

const TaskMetadataPopover = ({ taskMetadata, fromReviewHeader }: TaskMetadataPopoverProps) => {
  const metadata = fromReviewHeader ? (
    <a style={{ textDecoration: 'underline' }}>
      <strong>Metadata</strong>
    </a>
  ) : (
    <a style={{ color: theme.colors.periwinkle100 }}>
      <strong>Metadata</strong>
    </a>
  );

  return (
    <div style={{ marginRight: theme.spacing(2) }}>
      <Popover
        className={''}
        popover={
          <div style={{ width: 450, padding: 12 }}>
            <ReactJsonView
              src={taskMetadata}
              enableClipboard={false}
              name={false}
              displayDataTypes={false}
              displayObjectSize={false}
            />
          </div>
        }
        targetOpen={metadata}
        targetClosed={metadata}
      />
    </div>
  );
};

export default TaskMetadataPopover;
